export enum ConfigFieldEnum {
    apiKey = 'apiKey',
    environment = 'environment',
    idSchema = 'idSchema',
    clientId = "clientId",
    lang = 'lang',
    authProvider = 'authProvider'
}